<ng-template #content let-modal>

    <div class="modal-header bg-dark">
        <h5 class="modal-title" id="changeStateLabel">{{label}}</h5>
        <button type="button" class="close text-light" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="movimientoForm">
        <div class="modal-body">
            <div class="row justify-content-center">
                <div class="col-md-12">
                    <app-input type="text" label="Fecha" size="lg" idForm="InputFecha" placeholder="Fecha"
                        [autocomplete]="false" iconPrepend="fas fa-calendar-alt" [readOnly]="true"
                        [control]="movimientoForm.get('fechaMovimiento')"></app-input>
                </div>
                <div class="col-md-12">
                    <app-input type="text" [label]="labelMonto" size="lg" idForm="InputValor" placeholder="Monto"
                        [autocomplete]="false" iconPrepend="fas fa-dollar-sign"
                        [control]="movimientoForm.get('montoMovimiento')" (input)="onlyNumber($event)"></app-input>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="InputMotivo">Motivo</label>    
                        <textarea class="form-control" rows="5" cols="40"
                        id="InputMotivo" name="InputMotivo"
                        placeholder="Ingresar motivo"
                        autocomplete="off"
                        [formControl]="movimientoForm.get('motivoMovimiento')"></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="submit" name="add" class="btn btn-outline-success" (click)="modal.close(movimientoForm.value)"
                [disabled]="!movimientoForm.valid">
                <i class="fas fa-exchange-alt"></i> Aceptar
            </button>
            <button type="button" class="btn btn-outline-danger" (click)="modal.dismiss('close')"><i
                    class="fas fa-times"></i> Cancelar</button>
        </div>
    </form>
</ng-template>

<button type="button" class="{{cssClass}}" title="{{label}}" (click)="open(content)">
    <i class='{{icon}}'></i> {{label}}
</button>